import WithSidebar from 'Layout/WithSidebar';
import GeneralInfoBox from 'components/GeneralInfoBox';
import NavigationSideBar from 'components/NavigationSideBar';
import Banner from 'components/Banner';
import legalInfoBanner from 'images/legal-info-banner.jpg';
import { aboutProductFiles } from 'components/PDFBox/mockData';
import PDFBox from 'components/PDFBox';
import { data, titles } from './mockData';
import React from 'react';
import NavigationSectionWrapper from 'components/NavigationSideBar/NavigationSectionWrapper';
import { calculateActiveIndex } from 'components/NavigationSideBar/helpers';

const TermsAndConditions = () => {
    const [sectionsData, setSectionsData] = React.useState({});
    const [activeIndex, setActiveIndex] = React.useState(0);

    const boxes = data.map(item => (
        <GeneralInfoBox key={item.title}>
            <h3>{item.title}</h3>
            {item.blocks.map((p, index) => (
                <p key={index}>{p}</p>
            ))}
        </GeneralInfoBox>
    ));

    const pageContent = [<PDFBox title="Privacy policy" data={[aboutProductFiles[0]]} />, ...boxes];

    const arrLength = pageContent.length;
    const [refs, setRefs] = React.useState([]);

    React.useEffect(() => {
        setRefs(refs =>
            Array(arrLength)
                .fill()
                .map((_, i) => refs[i] || React.createRef()),
        );
    }, [arrLength]);

    React.useEffect(() => {
        setActiveIndex(calculateActiveIndex(sectionsData));
    }, [sectionsData]);

    return (
        <>
            <Banner title="Terms & Conditions" image={legalInfoBanner} buttonText="Read more" />

            <section className="container">
                <WithSidebar
                    containerType="type-1"
                    Sidebar={<NavigationSideBar items={titles} refs={refs} activeIndex={activeIndex} />}
                >
                    {pageContent.map((item, index) => (
                        <div ref={refs[index]} key={index}>
                            <NavigationSectionWrapper index={index} setData={setSectionsData}>
                                {item}
                            </NavigationSectionWrapper>
                        </div>
                    ))}
                </WithSidebar>
            </section>
        </>
    );
};

export default TermsAndConditions;
